<!-- Modal Backdrop -->
<div class="modal-backdrop" [ngClass]="{'visible': isVisible}"></div>

<!-- Modal Dialog -->
<div class="modal-dialog" [ngClass]="{'visible': isVisible}">
    <div class="modal-content">
        <!-- Close Button -->
        <button type="button" class="close-button" (click)="hide()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>

        <!-- Modal Header -->
        <div class="modal-header">
            <h5 class="modal-title">{{title}}</h5>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
            <div class="info-banner">
                <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <span class="info-text">Stay Connected — Even if You Change Jobs</span>
            </div>

            <div class="modal-message">
                <p class="message-header">Your work email might not last forever.</p>
                <p class="message-subtext">If you leave your current company, you could lose access to your GigSumo account, messages, jobs, and personal network.</p>
            </div>

            <div class="instruction-box">
                <div class="instruction-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="9 11 12 14 22 4"></polyline>
                        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
                    </svg>
                </div>
                <div class="instruction-content">
                    <strong>Add a personal email (like Gmail or Outlook)</strong>
                    <p>This helps you</p>
                </div>
            </div>

            <div class="benefits-list">
                <div class="benefit-item">
                    <svg class="check-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Recover your account easily</span>
                </div>
                <div class="benefit-item">
                    <svg class="check-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Continue receiving alerts and updates</span>
                </div>
                <div class="benefit-item">
                    <svg class="check-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>Stay plugged into your network</span>
                </div>
            </div>

            <div class="privacy-note">
                <svg class="warning-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="16" x2="12" y2="12"></line>
                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
                <span>Your personal email will only be used for account recovery and important notifications.</span>
            </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="hide()">Skip for Now</button>
            <button *ngIf="buttonName != null" type="button" class="btn btn-primary" (click)="routeTo()">
                {{ buttonName }}
            </button>
        </div>
    </div>

</div>